import { Component, Inject, ViewChildren, QueryList, ViewChild, AfterViewInit, OnInit, Renderer2 } from '@angular/core';
import { HttpService, UtilService } from '@app/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FocusNextDirective } from '@app/shared/focus-next.directive';
import { environment } from '@env';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { Autocomplete } from '@componentes/autocomplete';
import { FormDialog } from '@componentes/form-dialog';
import { FormularioPrefs } from '@componentes/formulario';
import { DataSource } from '@angular/cdk/collections';
import dayjs from 'dayjs';


@Component({
	selector: 'app-informew-dialog',
	templateUrl: 'informeWDialog.html',
	styleUrls: ['informeWDialog.css'],
})
export class InformeWDialog implements OnInit, AfterViewInit  {

	constructor(
	    public dialogRef: MatDialogRef<InformeWDialog>,
	    private httpService: HttpService,
		private utilService: UtilService,
		private prestaDialogo: MatDialog,
		private obraDialogo: MatDialog,
		private fb: FormBuilder,
	    @Inject(MAT_DIALOG_DATA) public data: any,
		private renderer: Renderer2,
	) { }

	templateForm = new FormGroup({
		template: new FormControl(null)
	});

	signatureForm = new FormGroup({
		ifplantilla: new FormControl(),
		signed: new FormControl(false),
		aproved: new FormControl(false),
		signature: new FormControl(null),
		anexar: new FormControl(null)
	});
	ocupado = false;
	numeroInforme = 1;
	sonInformes = 1;
	tipouser = 0;
	addinforme = false;
	anteriores = [];
	hardware = [];
	file = null;
	templates = [{
		value: 1,
		label: 'Simple',
		content: '<h2>Content</h2><br/><p>Super texto</p><img src="https://placekitten.com/200/300"><br>'
	}];

	signatures = [{
		id: 1,
		name: 'Dr. Fernandez'
	}];

	useRtf = false;

	destacado = [{ atributo: 'destacado', clase: 'separaautocomplete' }, { atributo: 'modificar', clase: 'modificarautocomplete' }, { atributo: 'eliminar', clase: 'eliminarautocomplete' }];
	selectedTemplate: {value: number, label: string, content: string} = null;

    editorConfig = {
		cabecera:	{
			placeholder: 'Write the report here...',
			toolbar: [ 'undo',
			'redo',
			'|',
			'heading',
			'|',
			'fontFamily',
			'fontSize',
			'fontColor',
			'fontBackgroundColor',
			'|',
			'bold',
			'italic',
			'bulletedList',
			'numberedList',
			'|',
			'indent',
			'outdent' ]
		},
		cuerpo:	{
			placeholder: 'Write the report here...',
			toolbar: [ 'undo',
			'redo',
			'|',
			'heading',
			'|',
			'fontFamily',
			'fontSize',
			'fontColor',
			'fontBackgroundColor',
			'|',
			'bold',
			'italic',
			'bulletedList',
			'numberedList',
			'|',
			'indent',
				'outdent',
				'insertImage']
		},
		pie:	{
			placeholder: 'Escribe aquí el pié...',
			toolbar: [ 'undo',
			'redo',
			'|',
			'heading',
			'|',
			'fontFamily',
			'fontSize',
			'fontColor',
			'fontBackgroundColor',
			'|',
			'bold',
			'italic',
			'bulletedList',
			'numberedList',
			'|',
			'indent',
				'outdent',
				'insertImage']
		}
	};

	dialogoPrestaForm: FormularioPrefs = {
		url: 'prestador',
		campoID: 'id',
		focusNextGuardar: 5,
		campos: [
			{
				tipo: 'hidden',
				name: 'id',
				attrs: {}
			},
			{
				tipo: 'text',
				name: 'nombre',
				attrs: {
					placeholder: 'Name',
					clase: 'col s12',
					hint: 'Full Name',
					tabIndex: 1
				},
			},
			{
				tipo: 'text',
				name: 'domicilio',
				attrs: {
					placeholder: 'Address',
					clase: 'col s12',
					hint: 'Address',
					tabIndex: 2
				},
			},
			{
				tipo: 'text',
				name: 'localidad',
				attrs: {
					placeholder: 'City',
					clase: 'col s12',
					hint: 'City',
					tabIndex: 3
				},
			},
			{
				tipo: 'text',
				name: 'celular',
				attrs: {
					placeholder: 'Cell Phone',
					clase: 'col s12',
					hint: 'Cell Phone Number (+1212...)',
					tabIndex: 4
				},
			}
		]
	};


	dialogoObraForm: FormularioPrefs = {
		url: 'obrasocial',
		campoID: 'id',
		focusNextGuardar: 3,
		campos: [
			{
				tipo: 'hidden',
				name: 'id',
				attrs: {}
			},
			{
				tipo: 'text',
				name: 'denominacion',
				attrs: {
					placeholder: 'Insurance',
					clase: 'col s12',
					hint: 'Insurance Company',
					tabIndex: 1
				},
			},
			{
				tipo: 'text',
				name: 'localidad',
				attrs: {
					placeholder: 'City',
					clase: 'col s12',
					hint: 'City/Country',
					tabIndex: 2
				},
			}
		]
	};



	@ViewChild('templateF', null) templateF: NgForm;
	@ViewChild('signatureF', null) signatureF: NgForm;
	@ViewChild('busObraSocial', null) busObraSocial: Autocomplete;
	@ViewChild('busPrestador', null) busPrestador: Autocomplete;
	@ViewChild('busPlantilla', null) busPlantilla: Autocomplete;
	@ViewChild('ifCabecera', null) ifCabecera;

	@ViewChildren(FocusNextDirective) focusElements: QueryList<FocusNextDirective>;
	historyList = false;
	cargandoHistory = true;
	informeForm = new FormGroup( {
		iftitulo: new FormControl(''),
		ifcabecera: new FormControl(''),
		ifcuerpo: new FormControl(''),
		iffirma: new FormControl(''),
		ifstudy: new FormControl(''),
		ifserver: new FormControl(''),
		ifobrasocial: new FormControl(''),
		ifmedicoref: new FormControl(''),
		ifequipo: new FormControl(''),
		iffecha: new FormControl(''),
		numero_informe: new FormControl('')
	});
	uploadForm = new FormGroup( {
		ufserie: new FormControl('', Validators.required),
		ufarchivo: new FormControl(''),
		ufhidden: new FormControl('', Validators.required)
	});

	ngOnInit() {
		this.informeForm.patchValue({ifstudy: this.data.study, ifserver: this.data.server});
		this.signatures = this.data.signatures;
		this.hardware = this.data.hardware;
		this.useRtf = this.data.serverActual.usertf;
		this.addinforme = this.data.serverActual.addinforme;
		this.tipouser = this.data.informe.tipouser;
		if (this.data.cuantos) {
			this.sonInformes = this.data.cuantos;
		}
		this.busObraSocial.customSearch = (busqueda) => {
			return new Promise(resolve => {
				this.httpService.get('obrasocial?active=1&texto=' + busqueda).then((data) => {
					let noCrear = false;
					if (data) {
						const arreglo = [];
						data.data.forEach((valor) => {
							if (valor.id && valor.denominacion) {
								arreglo.push({id: valor.id, label: valor.denominacion, value: valor.denominacion});
								if (valor.denominacion.toLowerCase() == busqueda.toLowerCase()) {
									noCrear = true;
								}
							}
						});
						if (busqueda.length > 3) {
							if (!noCrear) {
								arreglo.push({ id: -1, label: 'New I.C.' + busqueda, value: 'New I.C. ' + busqueda, destacado: 'destacado' });
							}
						}
						resolve(arreglo);
					} else {
						if (busqueda.length > 3) {
							resolve([{ id: -1, label: 'New I.C.' + busqueda, value: 'Crear I.C. ' + busqueda, destacado: 'destacado'}]);
						}
					}
				});
			});
		};
		this.busPrestador.customSearch = (busqueda) => {
			return new Promise(resolve => {
				this.httpService.get('prestador?active=1&texto=' + busqueda).then((data) => {
					let noCrear = false;
					if (data) {
						const arreglo = [];
						data.data.forEach((valor) => {
							if (valor.id && valor.nombre) {
								arreglo.push({ id: valor.id, label: valor.nombre, value: valor.nombre });
								if (valor.nombre.toLowerCase() == busqueda.toLowerCase()) {
									noCrear = true;
								}
							}
						});
						if (busqueda.length > 3) {
							if (!noCrear) {
								arreglo.push({ id: -1, label: 'New ' + busqueda, value: 'New ' + busqueda, destacado: 'destacado' });
							}
						}
						resolve(arreglo);
					} else {
						if (busqueda.length > 3) {
							resolve([{ id: -1, label: 'New ' + busqueda, value: 'New ' + busqueda, destacado: 'destacado' }]);
						}
					}
				});
			});
		};
		this.busPlantilla.customSearch = (busqueda) => {
			return new Promise(resolve => {
				this.httpService.get('plantilla?active=1&hardware_id=' + this.data.server + '&texto=' + busqueda).then((data) => {
					if (data) {
						const arreglo = [];
						let codigo = '';
						let queid = 0;
						let encontrado = [];
						data.data.forEach((valor) => {
							if (valor.id && valor.codigo) {
								codigo = valor.codigo;
								queid = valor.id;
								if (codigo.toLowerCase() === busqueda.toLowerCase()) {
									encontrado = [codigo, queid];
								}
							}
						});
						if (data.data.length == 1 || encontrado.length) {
							if (encontrado.length) {
								codigo = encontrado[0];
								queid = encontrado[1];
							}
							if (this.informeForm.get('ifcabecera').value.length < 3) {
								arreglo.push({ id: -2, label: 'Destroy ' + codigo + '|' + queid + '|', value: 'Modify ' + codigo + '|' + queid + '|', eliminar: 'eliminar' });
							} else {
								arreglo.push({ id: -2, label: 'Modify ' + codigo + '|' + queid + '|', value: 'Modify ' + codigo + '|' + queid + '|', modificar: 'modificar' });
							}
						}
						if (busqueda.length > 3 && encontrado.length < 1) {
							arreglo.push({ id: -1, label: 'Make ' + busqueda, value: 'Make ' + busqueda, destacado: 'destacado' });
						}
						data.data.forEach((valor) => {
							if (valor.id && valor.codigo) {
								arreglo.push({ id: valor.id, label: valor.codigo, value: valor.codigo, contenido: valor.contenido });
								codigo = valor.codigo;
								queid = valor.id;
							}
						});
						resolve(arreglo);
					} else {
						if (busqueda.length > 3) {
							resolve([{ id: -1, label: 'Make ' + busqueda, value: 'Make ' + busqueda, destacado: 'destacado' }]);
						}
					}
				});
			});
		};
	}


	cargaObraSoc(evento) {
		if (evento && evento.id && evento.id == -1) {
/*
// Crear de una
			this.httpService.post('obrasocial', { denominacion: this.busObraSocial.value.value.substr(11)}).then( (data) => {
				if (data && data.datos && data.datos.id) {
					this.busObraSocial.value = { id: data.datos.id, value: data.datos.denominacion, label: data.datos.denominacion};
				}
			});
*/
			const dialogRef = this.obraDialogo.open(FormDialog, {
				width: '600px',
				data: {
					prefs: this.dialogoObraForm,
					formtitle: 'New Insurance Company',
					formhint: 'New Insurance Company Data',
					registro: { id: 0, denominacion: evento.value.substr(11) }
				}
			});
			dialogRef.afterClosed().toPromise().then((resulta) => {
				console.log('se cierra con ', evento.value.substr(11));
				this.busObraSocial.limpiar();
				this.busObraSocial.focus();
			});
		}
		// this.busPrestador.focus();
	}

	cargaPrestador(evento) {
		if (evento && evento.id && evento.id == -1) {
			const dialogRef = this.prestaDialogo.open(FormDialog, {
				width: '600px',
				data: {
					prefs: this.dialogoPrestaForm,
					formtitle: 'New Refereal Doctor',
					formhint: 'Referal Doctor data',
					registro: { id: 0, nombre: evento.value.substr(6) }
				}
			});
			dialogRef.afterClosed().toPromise().then((resulta) => {
				this.busPrestador.limpiar();
				this.busPrestador.focus();
			});

			// this.busPrestador.limpiar();
		}
		this.ifCabecera.focus();
	}

	cargaPlantilla(evento) {
		if (evento && evento.id && evento.id == -1) {
			this.httpService.post('plantilla', { codigo: this.busPlantilla.value.value.substr(6), hardware_id: this.data.server, contenido: this.informeForm.get('ifcabecera').value }).then((data) => {
				if (data && data.success) {
					this.utilService.notification('Template created');
				}
			});
		} else if (evento && evento.id && evento.id == -2) {
			console.log('tengo ', this.busPlantilla.value.value);
			const texto = this.busPlantilla.value.value;
			const identificador = texto.substring(
				texto.indexOf('|') + 1,
				texto.lastIndexOf('|')
			);
			if (this.informeForm.get('ifcabecera').value.length < 5) {
				this.httpService.delete('plantilla/' + identificador).then((data) => {
					if (data && data.success) {
						this.utilService.notification('Template Deleted');
					}
				});
			} else {
				this.httpService.put('plantilla/' + identificador, { contenido: this.informeForm.get('ifcabecera').value }).then((data) => {
					if (data && data.success) {
						this.utilService.notification('Template updated');

					}
				});
			}

		} else {
			if (evento.contenido) {
				if (this.signatureForm.value.anexar) {
					this.informeForm.patchValue({ ifcabecera: this.informeForm.get('ifcabecera').value +  evento.contenido });
				} else {
					this.informeForm.patchValue({ ifcabecera: evento.contenido });
				}
				this.signatureForm.patchValue({ anexar: false });
			}
		}
		this.ifCabecera.focus();
	}



	ngAfterViewInit() {
		const dataCons = {
			columna: 'StudyDate',
			cuantos: 10,
			datosEst: '',
			direccion: 'desc',
			fecha: null,
			paciente: this.data.study.PatientID,
			pag: 0,
			servidor: this.data.server,
			tipoEst: []
		};
		if (this.data.informe && this.data.informe.usuario_id) {
			const firma = this.signatures.filter((valor) => valor.id == this.data.informe.usuario_id);
			if (firma) {
				this.signatureForm.patchValue({ signature: firma[0] });
			}
		}
		if (this.data.informe && this.data.informe.contenido) { // Cargo el contenido...
			this.informeForm.patchValue({ ifcabecera: this.data.informe.contenido });
		}
		if (this.data.informe && this.data.informe.firmado) {
			this.signatureForm.patchValue({signed: true});
		}
		if (this.data.informe && this.data.informe.aprobado) {
			this.signatureForm.patchValue({ aproved: true });
		}
		if (this.data.informe && this.data.informe.camposextra && this.data.informe.camposextra.titulo) {
			this.informeForm.patchValue({ iftitulo: this.data.informe.camposextra.titulo });
		} else if (this.data.study.StudyDescription) {
			this.informeForm.patchValue({ iftitulo: this.data.study.StudyDescription });
		}
		if (this.data.informe && this.data.informe.camposextra && this.data.informe.camposextra.obrasocial) {
			this.informeForm.patchValue({ ifobrasocial: this.data.informe.camposextra.obrasocial });
		}
		if (this.data.informe && this.data.informe.camposextra && this.data.informe.camposextra.medicoref) {
			this.informeForm.patchValue({ ifmedicoref: this.data.informe.camposextra.medicoref });
		}
		if (this.data.informe && this.data.informe.camposextra && this.data.informe.camposextra.equipo) {
			this.informeForm.patchValue({ ifequipo: this.data.informe.camposextra.equipo });
		}
		if (this.data.informe && this.data.informe.camposextra && this.data.informe.camposextra.fechaInforme) {
			this.informeForm.patchValue({ iffecha: dayjs(this.data.informe.camposextra.fechaInforme )});
		}
		if (this.data.informe && this.data.informe.numero_informe) {
			this.numeroInforme = this.data.informe.numero_informe;
		}
		this.informeForm.patchValue({ numero_informe: this.numeroInforme });
		this.httpService.post('img/study', dataCons).then( anteriores => {
			this.anteriores = anteriores.data;
			this.cargandoHistory = false;
		});
/*
		this.renderer.listen(this.ifCabecera.nativeElement, 'paste', (event) => {
			console.log('tengo paste', event);
		});*/
	}

	toggleViewPort() {
		return this.historyList = !this.historyList;
	}

	compareEquipos(object1: any, object2: any) {
		return object1 && object2 && object1.id == object2.id;
	}

	convertirRtf() {
		this.httpService.post('inf/rtf', this.informeForm.getRawValue()).then(resultado => {
			this.informeForm.patchValue({ ifcabecera: resultado.contenido });
		});

	}

	canceLar() {
		this.dialogRef.close();
	}
	onSiguiente() {
		this.dialogRef.close({ siguiente: this.numeroInforme , informe: this.informeForm.getRawValue(), firmas: this.signatureForm.getRawValue() });
	}
	onSubmit() {
		this.dialogRef.close({ informe: this.informeForm.getRawValue(), firmas: this.signatureForm.getRawValue()});
	}

	onFileChange($event) {
		this.file = $event.target.files[0]; 
		this.uploadForm.controls['ufhidden'].setValue(this.file ? this.file.name : ''); 
	}

	limpiarSerie() {
		this.httpService.post('img/deleteSerie/' + this.data.study.StudyInstanceUID, { server: this.data.server, name: this.uploadForm.controls['ufserie'].value}).then((data) => {
			if (data.success) {
				this.utilService.notification('Deleted Series');
				this.dialogRef.close();
			} else {
				this.utilService.notification(data.message);
			}
		});

	}

	subirArchivo() {
		let formData: FormData = new FormData();
		formData.append('uploadFile', this.file, this.file.name);
		formData.append('StudyInstanceUID', this.data.study.StudyInstanceUID);
		formData.append('server', this.data.server);
		formData.append('tituloSerie', this.uploadForm.controls['ufserie'].value);
		let headers = new Headers();
		headers.append('Content-Type', 'multipart/form-data');
		headers.append('Accept', 'application/json');
		const optOptions = {
			withCredentials: true,
			headers: headers
		};
		this.ocupado = true;
		this.httpService.file('img/newSerie/' + this.data.study.StudyInstanceUID, formData, optOptions).then((data: any) => {
			if (data.success && data.success) {
				this.ocupado = false;
				this.utilService.notification('Series Loaded');
				this.dialogRef.close();
			} else {
				this.utilService.notification(data.message);
			}
		}).catch((eso) => {
			this.utilService.notification("Couldn't upload serie");
			this.ocupado = false;
		});

	}

	visor(elemento) {
		elemento.servidor = this.data.server;
		this.httpService.put('img/share/2/' + elemento.StudyInstanceUID, elemento).then((data) => {
			window.open(data.uriVisor + data.link, '_blank');
		});
	}

	handleSelectTemplate(event: any){
		this.selectedTemplate = event;
	}

	handleClear(event){
		this.selectedTemplate = null;
	}

	handleCopyTemplate(){
		this.utilService.copyClipboard(this.selectedTemplate.content);
	}

	handleInsertTemplate(){
		this.informeForm.patchValue({ifcabecera: this.selectedTemplate.content });
	}

	isSigned() {
		return(this.signatureForm.value.signed);
	}

}
